import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// Self-hosted fonts (DSGVO: no external Google Fonts request). Family names stay 'Inter'/'Outfit'.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";
import "@fontsource/outfit/800.css";
import "@fontsource/outfit/900.css";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const app = (
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

const rootEl = document.getElementById("root");
// The prerendered SEO snapshot lives inside #root so crawlers get full HTML.
// Its markup intentionally differs from the React tree, so we discard it and do
// a clean client render (no hydration). This also removes the white cover layer.
rootEl.innerHTML = "";
createRoot(rootEl).render(app);
